/* eslint-disable max-depth */
/* eslint-disable complexity */
/**
 * 时间格式化工具
 * @author lidan
 */

/**
 * 将数字格式化为"00X" 格式
 * @param {number} value 需要格式化的数字
 * @param {number} n 格式化之后的位数
 **/
export function formatNumberToString(value: number, n = 2): string {
  const str = '' + value

  if (n <= str.length) {
    return str
  }

  const list = []
  for (let i = 0, len = n - str.length; i < len; i++) {
    list.push('0')
  }
  return list.join('') + str
}

/**
 * @desc 格式化时间秒
 * @param 秒数
 * @param type 1: 00:01:20; 2: 3秒 1分20秒 1小时30分10秒
 * @returns {*}
 */
// eslint-disable-next-line max-statements
export function formatSeconds(value: any = 0, type = 1): string {
  let second: any = parseInt(value)
  let minute: any = 0
  let hour: any = 0
  let result = ''

  if (type == 1) {
    if (second > 60) {
      minute = second / 60
      second = second % 60
      if (minute > 60) {
        hour = minute / 60
        minute = minute % 60
      }
      minute = parseInt(minute)
      second = parseInt(second)
      hour = parseInt(hour)

      if (second < 10) {
        second = '0' + second
      }
      result = '' + second

      if (minute > 0) {
        if (minute < 10) {
          minute = '0' + minute
        }
        result = '' + minute + ':' + result
      }

      if (hour > 0) {
        if (hour < 10) {
          hour = '0' + hour
        }
        result = '' + hour + ':' + result
      }
    } else {
      result = '00:' + formatNumberToString(second)
    }

    return result
  } else if (type == 2) {
    if (second > 60) {
      minute = second / 60
      second = second % 60
      if (minute > 60) {
        hour = minute / 60
        minute = minute % 60
      }
    }
    let result =
      '' +
      (parseInt(second) < 10 ? '0' + parseInt(second) : parseInt(second)) +
      '秒'
    if (minute > 0) {
      result =
        '' +
        (parseInt(minute) < 10 ? '0' + parseInt(minute) : parseInt(minute)) +
        '分' +
        result
    }
    if (hour > 0) {
      result =
        '' +
        (parseInt(hour) < 10 ? '0' + parseInt(hour) : parseInt(hour)) +
        '小时' +
        result
    }
    return result
  }
  return ''
}

/**
 * 将数字格式化为带单位的表达
 * @return {String} 格式化后结果
 */
export function formatNum(val: any): string {
  const count = parseInt(val || 0, 10)

  if (count >= 10000) {
    return count / 1000 / 10 + '万'
  } else if (count >= 1000) {
    return count / 100 / 10 + '千'
  }
  return '' + count
}

/**
 * 将数字格式化为带单位的表达
 * 进超过5位数在行数据转换
 * @return {String} 格式化后结果
 */
export function formatFollowNum(val: any): string {
  const count: number = parseInt(val || 0, 10)
  if (count >= 10000) {
    return count / 10 + '万'
  }
  return '' + count
}
